import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";
import { FollowUpToggle } from "./FollowUpToggle";
import { OnHoldToggle } from "./onHoldToggle";

export const TaskRow = ({ data }: { data: any }) => {
  const flowId = data?.flowId;

  return (
    <RowsWrapper className="Financial information">
      {/* <NormalInfoWrapper $header>Task Details</NormalInfoWrapper> */}

      <NormalInfoWrapper $isLast>
        <div>On follow up</div>
        <div>
          <FollowUpToggle flowId={flowId} data={data} />
        </div>
      </NormalInfoWrapper>
      <NormalInfoWrapper $isLast>
        <div style={{ marginLeft: "11px" }}>On hold</div>
        <div style={{ textAlign: "end" }}>
          <OnHoldToggle flowId={flowId} data={data} />
        </div>
      </NormalInfoWrapper>
    </RowsWrapper>
  );
};